export const GET_FORUMS = 'GET_FORUMS';
export const SET_FORUMS = 'SET_FORUMS';
export const ADD_FORUM = 'ADD_FORUM';
export const DELETE_FORUM = 'DELETE_FORUM';
export const UPDATE_FORUM = 'UPDATE_FORUM';

export default {
    namespaced: true,
    state: {
      forums: []
    },
    getters: {
      [GET_FORUMS](state) {
        return state.forums
      },
    },
    mutations: {
      [SET_FORUMS](state, forums) {
        state.forums = forums.reverse();
      },
      [ADD_FORUM](state, forum) {
        state.forums = [forum, ...state.forums]
      },
      [DELETE_FORUM](state, forum) {
        const forums = state.forums.filter((f) => f.slug !== forum.slug)
        state.forums = forums
      },
      [UPDATE_FORUM](state, forum) {
        const forums = state.forums
        const updateFourmIndex = forums.findIndex((f) => f.id === forum.id)
        if (updateFourmIndex !== -1) {
          forums[updateFourmIndex] = forum
          state.forums = forums
          
        }
      },
    }
}